import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from '@app/app.component';
import { CoreModule } from '@app/core/core.module';
import { environment } from '@env/environment';
import { metadata } from '@env/metadata';
import { TkHttpModule } from '@technocom/common/http';
import { ENVIRONMENT, ENVIRONMENT_CONTEXT, TkEnvironmentModule } from '@technocom/core';
import { SharedModule } from '@app/shared/shared.module';
import '@angular/common/locales/global/ru';
import { NgxsModule } from '@ngxs/store';
import { HttpClientModule } from '@angular/common/http';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { TkLocaleModule } from '@technocom/l10n';
import { AppState } from '@app/shared/app.state';

@NgModule({
  declarations: [AppComponent],
  providers: [
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    {
      provide: ENVIRONMENT_CONTEXT,
      useValue: metadata,
    },
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgxsModule.forRoot([AppState], {
      selectorOptions: { injectContainerState: false, suppressErrors: false },
      developmentMode: !environment.production,
    }),
    environment.options.plugins,
    // TK
    TkHttpModule,
    TkEnvironmentModule,
    TkLocaleModule,
    // Проект
    CoreModule,
    SharedModule,
    HttpClientModule,
    ScrollViewModule,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
